import './scss/main.css'
import 'antd/dist/reset.css'
import './setup/extensions'
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import registerInterceptors from './setup/interceptors'

registerInterceptors()
const container = document.getElementById('root')
const root = createRoot(container!)
root.render(<App />)
